module.exports = __webpack_public_path__ + "static/media/popup_character_OK.d9e33f29.svg";